import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';
import { globalFilterSelector } from 'utility/redux/globalFilter.selector';

const CMDetailsMonthRangeHttpRequest = (() => {
  const apiName = 'cmDetailsMonthRange';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `filter/month-range`;
  generatedHttpThunk.globalFilterSelector = globalFilterSelector;
  return generatedHttpThunk.generatePortfolioThunk();
})();

export default CMDetailsMonthRangeHttpRequest;
